import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en/translation.json';
import it from '../locales/it/translation.json';
import es from '../locales/es/translation.json';
import {
  LOCALE_STORAGE_KEY,
  resolveAppLocale,
  SUPPORTED_LOCALES,
} from './localeUtils';

export { LOCALE_STORAGE_KEY, resolveAppLocale, SUPPORTED_LOCALES };

const saved = typeof localStorage !== 'undefined'
  ? localStorage.getItem(LOCALE_STORAGE_KEY)
  : null;
const initialLocale = SUPPORTED_LOCALES.includes(saved) ? saved : 'en';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    it: { translation: it },
    es: { translation: es },
  },
  lng: initialLocale,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export function setAppLocale(locale) {
  const next = SUPPORTED_LOCALES.includes(locale) ? locale : 'en';
  localStorage.setItem(LOCALE_STORAGE_KEY, next);
  if (typeof document !== 'undefined') {
    applyBrowserTranslateOptOut(next);
  }
  return i18n.changeLanguage(next);
}

/**
 * Opt out of Edge/Chrome auto-translate without mutating body.className.
 * Theme layouts depend on body.theme-*. Set html.lang to the active app locale
 * so native constraint validation (e.g. required fields) matches the UI language;
 * translate=no still blocks the browser "Translate this page?" prompt.
 */
function applyBrowserTranslateOptOut(locale = i18n.language) {
  const html = document.documentElement;
  const lang = resolveAppLocale(locale);
  html.lang = lang;
  html.setAttribute('translate', 'no');
  if (document.body) {
    document.body.removeAttribute('translate');
    document.body.classList.remove('notranslate');
  }
  if (!document.querySelector('meta[name="google"][content="notranslate"]')) {
    const meta = document.createElement('meta');
    meta.name = 'google';
    meta.content = 'notranslate';
    document.head.appendChild(meta);
  }
}

if (typeof document !== 'undefined') {
  applyBrowserTranslateOptOut();
}

export default i18n;
